module.exports = {
	extends: [
		'/',
		'templates',
		'artCrm',
		'entity',
		'recordController'
	],

	config: {
		entityContext: 'cooperation',
		privilegeBase: 'artcrm_cooperations'
	}
}